import React, { PropsWithChildren } from "react";

import * as css from "./styles/Option";

export type Option<V> = {
  label: string;
  value: V;
};

type Props<V = unknown> = {
  option: Option<V>;
  onClick(value: Option<V>): void;
};

export function Option<V extends unknown>(
  props: PropsWithChildren<Props<V>>
): React.ReactElement {
  const onClick = (): void => {
    props.onClick(props.option);
  };

  return (
    <li className={css.optionCls}>
      <button className={css.buttonCls} onClick={onClick}>
        {props.option.label}
      </button>
    </li>
  );
}
